import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";

export function SupplierAdminContactForm() {
  return (
    <>
      <TextInput name="name" label="Name" autoFocus />
      <TextInput name="role" label="Role" />
      <TextInput name="email" label="Email" />
      <TextInput name="phone" label="Phone" />
      <TextAreaInput
        name="description"
        label="Description"
        className="col-span-full"
        textAreaProps={{ rows: 3 }}
      />
    </>
  );
}
